import { createSelector } from '@reduxjs/toolkit';

// Base selector
export const selectPolicies = (state) => state.policies;

// Sidebar vectors filtered by active tab (Human vs Non-Human)
export const selectSidebarVectors = createSelector(
  [selectPolicies],
  (policies) => {
    // console.log("policies",policies)
    // Note: API returns vectors for the specific type, so we just return state.vectors
    return policies.vectors;
  }
);

// Display data based on selected vector filter
export const selectDisplayData = createSelector(
  [selectPolicies],
  (policies) => {
    const { vectors, selectedVectorId } = policies;
    // console.log("policies",selectedVectorId);
    if (selectedVectorId === 'all') {
      return vectors;
    }

    return vectors.filter((v) => v.vector_id === selectedVectorId);
  }
);

// Paginated display data
export const selectPaginatedData = createSelector(
  [selectDisplayData, selectPolicies],
  (displayData, policies) => {
    const { templatePage, policiesPerPage } = policies;
    const start = (templatePage - 1) * policiesPerPage;
    return displayData.slice(start, start + policiesPerPage);
  }
);

// Pagination info
export const selectPaginationInfo = createSelector(
  [selectDisplayData, selectPolicies],
  (displayData, policies) => {
    const { templatePage, policiesPerPage } = policies;
    return {
      currentPage: templatePage,
      totalPages: Math.max(1, Math.ceil(displayData.length / policiesPerPage)),
      totalItems: displayData.length,
      itemsPerPage: policiesPerPage,
    };
  }
);


// Section title
export const selectSectionTitle = createSelector(
  [selectPolicies, selectDisplayData],
  (policies, displayData) => {
    const { selectedVectorId, activeFilterTab } = policies;

    if (selectedVectorId === 'all') {
      const typeLabel = activeFilterTab === 'human' ? 'Human' : 'Non-Human';
      return `${typeLabel} Attack Vectors`;
    }

    return `Details: ${displayData[0]?.attack_vector_name?.replace(/_/g, ' ') || 'Vector Details'}`;
  }
);

// New: Identity Selector (Used by the Modal)
export const selectIdentitiesForKey = (useCaseName, identityType) => 
  createSelector(
    [selectPolicies],
    (policies) => {
      const key = `${useCaseName}-${identityType}`;
      return policies.identitiesByUseCase[key] || [];
    }
  );